<app-demo [context]="demoContext" [sources]="sources">
  <div actions class="comment">Available since v1.8.1, undocumented</div>

  <div description>
    <p>
      As follows from the doc, the viewport is a scrollable area with a
      finite height. By default, the nearest ancestor of the
      <em>*uiScroll</em> container is treated as the Viewport. With the
      <em>viewportElement</em> setting we may change the default behavior and
      make another html element to be the Viewport.
    </p>
    <p>
      The value of <em>viewportElement</em> setting can be an html element or a
      function synchronously returning an html element. The second option is
      useful if the Viewport is a part of the template of the same component
      that contains the Scroller, and the <em>Datasource</em> is initialized
      before the view is ready (before <em>ngOnInit</em>).
    </p>
    <p>
      This sample shows a declarative way and uses
      <em>ViewChild</em> decorator and <em>#viewport</em> syntax to access the
      3d ancestor of the Scroller base container. This also could be achieved
      via native javascript methods, for example
    </p>
    <pre>{{ nativeSample }}</pre>
    <p>
      Note, using this feature is potentially dangerous, because any html
      element can be set as the Viewport this way. For example, the engine does
      not check whether this element is an ancestor of the Scroller element or
      not.
    </p>
  </div>
</app-demo>
